import {Injectable} from '@angular/core';

import {Http, Response}  from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';

import {Observable}  from 'rxjs/Observable';
// import 'rxjs/add/observable/throw';
// import * as Rx from 'rxjs';

import {StoreService}  from '../store/store.service';
import {CognitoAuthService} from '../auth/cognito.service';

declare const moment: any;

@Injectable()
export class AlertService {

    alerts: any[ ] = [];
    alertsParams: any = {};
    maxAlertDataCallRetries = 3;
    alertsDataSubscription;
    summarySubscription;

    idToken: string;
    customer: string;
    allEventIds: string;

    // TODO: This should be moved to some global location and defined there!
    summaryTemplate = [
        {
            "name": "System Compromise",
            "type": 0,
            "icon": "fa-bomb",
            "count": 0,
            "tooltip": "Behavior indicating a compromised system"
        },
        {
            "name": "Exploitation & Installation",
            "type": 1,
            "icon": "fa-bug",
            "count": 0,
            "tooltip": "Behavior indicating a successful exploit of a vulnerability or backdoor/RAT being installed on a system"            
        },
        {
            "name": "Delivery & Attack",
            "type": 2,
            "icon": "fa-sliders",
            "count": 0,
            "tooltip": "Behavior indicating an attempted delivery of an exploit"
        },
        {
            "name": "Reconnaissance & Probing",
            "type": 3,
            "icon": "fa-crosshairs",
            "count": 0,
            "tooltip": "Behavior indicating a bad actor attempting to discover information about your network"
        },
        {
            "name": "Organizational Insight",
            "type": 4,
            "icon": "fa-info-circle",
            "count": 0,
            "tooltip": "Behavior indicating policy violations, vulnerable software, or suspicious communications"
        }
    ];

    // constructor(private store: StoreService, private http: AuthHttp, private cognitoAuthService: CognitoAuthService) { }

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead

        return Observable.throw(errMsg);
    }

    constructor(private store: StoreService,
                private http: Http,
                private authHttp: AuthHttp,
                private cognitoAuthService: CognitoAuthService) {
    }

    // Gets the Alerts Summary sorted by type
    // Input parameters can be {timePeriod: 'w', alertSeverity: <num>, alertType: <num>}
    getAlertsSummary(params): Observable<any> {
        const self = this;
        var summary = [];

        return Observable.create(function(subscriber) {
            self.summarySubscription = self.getAlerts(params).subscribe(function(alerts){
                // TODO: the device types below should be some global value
                // TODO: some more of the fields need to be better computed (like new, icon, name)
                self.summaryTemplate.forEach(function(a){
                    a.count = alerts.filter(element => element.type == a.type).length;
                    summary.push(a);
                });
            }, function(err) {
                summary = [];
                console.log('Error in getAlertsSummary: ', err);
            });
            subscriber.next(summary);
        });
    }

    getAlerts(params, forceFetchAlertsFromAPI = false): Observable<any> {

        const self = this;

        return Observable.create(function (subscriber) {

            let doFetchAlertsFromAPI = false;

            if ((!self.store.isFresh()) || forceFetchAlertsFromAPI) {

                // console.log('Store is NOT FRESH!');
                self.store.delete('alertsParams');
                self.store.delete('alerts');
                doFetchAlertsFromAPI = true;
            } else {

                const storeAlerts = self.store.get('alerts');

                // console.log('storeAlerts.length !== 0', (storeAlerts.length !== 0) );

                const storeAlertsParams = self.store.get('alertsParams');

                let index = -1;
                const paramsPresent = storeAlertsParams.some(function (p) {
                    ++index;
                    return JSON.stringify(p) === JSON.stringify(params);
                });

                // console.log('paramsPresent = ', paramsPresent);
                // console.log('index = ', index);


                if ((storeAlerts.length !== 0) && (paramsPresent)) {

                    const alerts = storeAlerts[index];

                    // console.log('alerts at index = ' + index, alerts);

                    if (alerts == null) {

                        // console.log('alerts are NULL at index = ' + index, alerts);

                        doFetchAlertsFromAPI = true;
                    } else {

                        // console.log('Retrieving alerts from STORE');
                        // console.log('storeAlerts = ', storeAlerts);
                        // console.log('storeAlertsParams = ', storeAlertsParams);
                        // console.log('================');

                        subscriber.next(alerts);
                    }
                } else {
                    doFetchAlertsFromAPI = true;
                }

            }

            // Fetch alerts from the API only if the alerts in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchAlertsFromAPI) {

                // console.log('AlertService getting alerts from API because store is NOT FRESH');

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    self.customer = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];

                    self.alertsDataSubscription = self.callAlertsApi(params).subscribe(function (alerts) {

                        self.allEventIds = '';

                        // Adjust the Date field a bit in the Alerts list
                        alerts.forEach(function (alert) {
                            alert.date = new Date(alert.date);
                            alert.date = alert.date.toLocaleDateString('en-US') + ' ' + alert.date.toLocaleTimeString('en-US', { hour12: false });
                            // alert.date = alert.date.substring(0, 19).replace('T', ' ');
                            alert.event_count = (alert.event_ids) ? 1 + (alert.event_ids.match(/,/g) || []).length : 0;
                            // self.allEventIds += alert.event_ids ? (self.allEventIds ? ',' : '') + alert.event_ids : '';

                        });

                        self.alerts = alerts;
                        self.store.add('alertsParams', params);
                        self.store.add('alerts', alerts);
                        self.store.refresh();

                        // console.log('Got fresh alerts from API');
                        // console.log('alerts', self.store.get('alerts'));
                        // console.log('alertsParams', self.store.get('alertsParams'));
                        // console.log('================');

                        subscriber.next(alerts);

                    }, function (err) {

                        self.alerts = [];

                        // Retry fetching alerts until max number of retries is reached
                        self.alertsDataSubscription.unsubscribe();
                        --self.maxAlertDataCallRetries;
                        if (self.maxAlertDataCallRetries > 0) {
                            self.getAlerts(params);
                        }
                    });


                }).catch(function (err) {

                    console.log('Error in getIdTokenPromise()');
                    console.log(err);

                });

            }
        });

    }

    private callAlertsApi(params): Observable<any> {

        const json_token = {range: params.timePeriod, ip: params.ip};

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = this.idToken;

        return this.http.post(apiConfig.alertsURL, json_token, {headers: apiConfig.headers})
            .map(AlertService.extractData)
            .catch(AlertService.handleError);

    }

}



// WEBPACK FOOTER //
// /app/src/app/shared/alert/alert.service.ts